import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { listUser, User } from '@goldcast/api/backend';
import { computed, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';

import StudioMultiselect, { MultiselectItem } from '@/studioComponents/StudioMultiselect.vue';
import StudioMultiselectTriggerButton from '@/studioComponents/StudioMultiselectTriggerButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoLibraryCreatedByFilter',
  props: {
    selectedUserIds: {}
  },
  emits: ["update:selectedUserIds"],
  setup(__props: any, { emit }) {

const props = __props;





const store = useStore();
const isOpen = ref(false);
const isLoading = ref(false);
const userFilterItems = ref<MultiselectItem[]>([]);
const visibleUserFilterItems = ref<MultiselectItem[]>([]);
const searchTerm = ref('');

const selectedUserNames = computed(() => {
  return userFilterItems.value.filter(item => item.selected).map(item => item.title);
});

watch(
  () => props.selectedUserIds,
  newSelectedUserIds => {
    userFilterItems.value = userFilterItems.value.map(item => ({
      ...item,
      selected: newSelectedUserIds.includes(item.id)
    }));
  },
  { deep: true }
);

onMounted(() => {
  fetchOrgUserList();
});

const fetchOrgUserList = async () => {
  isLoading.value = true;
  try {
    const org = store.getters['org/getCurrentOrg'];
    const organizationUsers = (await listUser({
      queryParams: {
        organization: org.id,
        workspaces: 'all',
        exclude_goldcastevents_users: true
      }
    })) as User[];

    if (organizationUsers) {
      userFilterItems.value = organizationUsers.map(user => ({
        id: user.id,
        title: user.first_name + ' ' + user.last_name,
        selected: props.selectedUserIds.includes(user.id)
      }));
      visibleUserFilterItems.value = userFilterItems.value;
    }
  } catch (error) {
    console.error('Error fetching organization users:', error);
  } finally {
    isLoading.value = false;
  }
};

const updateVisibleUserFilterItems = (searchTerm: string) => {
  if (!searchTerm) {
    visibleUserFilterItems.value = userFilterItems.value;
    return;
  }

  visibleUserFilterItems.value = userFilterItems.value.filter(item =>
    item.title.toLowerCase().includes(searchTerm.toLowerCase())
  );
};

const handleToggleUserSelection = (userId: string) => {
  userFilterItems.value = userFilterItems.value.map(item => ({
    ...item,
    selected: item.id === userId ? !item.selected : item.selected
  }));

  const selectedIds = userFilterItems.value.filter(item => item.selected).map(item => item.id);

  emit('update:selectedUserIds', selectedIds);
};

const handleClearSelection = () => {
  userFilterItems.value = userFilterItems.value.map(item => ({
    ...item,
    selected: false
  }));
  isOpen.value = false;
  emit('update:selectedUserIds', []);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(StudioMultiselect, {
    shouldShowSearchInput: "",
    isOpen: isOpen.value,
    multiselectItems: visibleUserFilterItems.value,
    isLoading: isLoading.value,
    searchTerm: searchTerm.value,
    onOnToggleSelectItem: handleToggleUserSelection,
    onOnSearch: updateVisibleUserFilterItems,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (isOpen.value = false))
  }, {
    trigger: _withCtx(() => [
      _createVNode(StudioMultiselectTriggerButton, {
        selectedItemsTitles: selectedUserNames.value,
        suffix: { singular: 'Created By', plural: 'Created By' },
        characterLengthThreshold: 60,
        onOpen: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = !isOpen.value)),
        onClear: handleClearSelection
      }, null, 8, ["selectedItemsTitles"])
    ]),
    _: 1
  }, 8, ["isOpen", "multiselectItems", "isLoading", "searchTerm"]))
}
}

})